module.exports = __webpack_public_path__ + "static/media/auchan8.6cb9be9f.jpg";